











































































































































































































































































































































import moment from "moment";
import { InterventionApi } from "../../api/InterventionApi";
import _ from "lodash";
import { Routes } from "../../utils/Routes";
import OptionSelect from "../../core/Forms/OptionSelect.vue";
import { Intervention } from "../../models/Intervention";
import { TableColumn } from "../../models/UI/TableColumn";
import DisponibilitesEmployesModal from "./DisponibilitesEmployesModal.vue";
import AbsencesNonAssigneesModal from "./AbsencesNonAssigneesModal.vue";
import DisponibilitesCalendarLabels from "./DisponibilitesCalendarLabels.vue";
import ExportButton from "../../core/UI/ExportButton.vue";

export default {
    name: "DisponibilitesCalendar",
    components: {
        DisponibilitesCalendarLabels,
        AbsencesNonAssigneesModal,
        DisponibilitesEmployesModal,
        ExportButton,
        OptionSelect,
    },
    data() {
        return {
            selectedYear: moment().year(),
            selectedMonth: null,
            monthsList: [],
            dayList: [],
            dayNames: [],
            InterventionApi: new InterventionApi(),
            employes_list_url: Routes.employes_list,
            intervention_list_filter_url: Routes.intervention_list_filter,
            frequencesList: Intervention.Frequence,
            selectedFrequences: [],
            showDisponibilitesEmployesModal: false,
            disponibilitesEmployesModalStartDate: null,
            disponibilitesEmployesModalEndDate: null,
            showAbsencesNonAssigneesModal: false,
            absencesNonAssigneesModalStartDate: null,
            absencesNonAssigneesModalEndDate: null,
            absencesNonAssigneesModalFilterType: 0,
        };
    },
    created() {
        this.createMonthsList();
        this.createDayNames();
    },
    methods: {
        // Data
        createDayNames() {
            this.dayNames = [];
            for (let i = 0; i < 7; i++) {
                this.dayNames.push({
                    id: i,
                    name: moment().weekday(i).format("dddd"),
                });
            }
        },
        createMonthsList() {
            this.monthsList = [];
            for (let i = 0; i < 12; i++) {
                let month = moment().year(this.selectedYear).month(i);
                this.monthsList.push({
                    id: i,
                    name: month.format("MMMM"),
                    start_date: month.startOf("month").format("YYYY-MM-DD"),
                    end_date: month.endOf("month").format("YYYY-MM-DD"),
                });
            }
            this.getDisponibilites();
        },
        createDayList() {
            if (!this.selectedMonth) return;
            this.dayList = [];
            let firstDay = moment()
                .year(this.selectedYear)
                .month(this.selectedMonth.id)
                .startOf("month");
            let lastDay = moment(firstDay).endOf("month");
            //
            firstDay.startOf("week");
            lastDay.endOf("week");
            for (firstDay; firstDay.isBefore(lastDay); firstDay.add(1, "day")) {
                this.dayList.push({
                    id: firstDay.date(),
                    weekNumber: firstDay.week(),
                    weekStart: firstDay
                        .clone()
                        .startOf("week")
                        .format("YYYY-MM-DD"),
                    weekEnd: firstDay
                        .clone()
                        .endOf("week")
                        .format("YYYY-MM-DD"),
                    date: firstDay.format("YYYY-MM-DD"),
                    isActive: firstDay.month() === this.selectedMonth.id,
                });
            }
            this.getDisponibilites();
        },
        totalWeek(weekNumber) {
            let days = _.filter(this.dayList, { weekNumber: weekNumber });
            return _.reduce(
                days,
                function (res, day) {
                    res.heures_intervention += day.heures_intervention || 0;
                    res.heures_intervention_unassigned +=
                        day.heures_intervention_unassigned || 0;
                    res.heures_absences_unassigned +=
                        day.heures_absences_unassigned || 0;
                    res.heures_conges_unassigned +=
                        day.heures_conges_unassigned || 0;
                    res.heures_contrat += day.heures_contrat || 0;
                    res.disponibilites += day.disponibilites || 0;
                    return res;
                },
                {
                    heures_intervention: 0,
                    heures_intervention_unassigned: 0,
                    heures_absences_unassigned: 0,
                    heures_conges_unassigned: 0,
                    heures_contrat: 0,
                    disponibilites: 0,
                }
            );
        },
        totalMonth() {
            let self = this;
            let res = 0;
            if (this.selectedMonth) {
                _.each(this.dayList, function (day) {
                    res += day.disponibilites || 0;
                });
            }
            return res;
        },
        totalYear() {
            let self = this;
            let res = 0;
            _.each(this.monthsList, function (month) {
                res += month.disponibilites || 0;
            });
            return res;
        },
        getDisponibilites() {
            let self = this;
            let params = null;
            if (self.isFrequenceView) {
                params = {
                    frequences: _.chain(self.selectedFrequences)
                        .map("id")
                        .join(",")
                        .value(),
                };
            }
            if (self.selectedMonth) {
                _.each(self.dayList, function (day) {
                    if (!day.isActive) {
                        return;
                    }
                    let date = moment()
                        .year(self.selectedYear)
                        .month(self.selectedMonth.id)
                        .date(day.id);
                    self.InterventionApi.getDisponibilites(
                        date.format("YYYY-MM-DD"),
                        date.format("YYYY-MM-DD"),
                        params
                    ).then(function (res) {
                        _.assign(day, res);
                        self.$forceUpdate();
                    });
                });
            } else {
                _.each(self.monthsList, function (month) {
                    let start_date = moment()
                        .year(self.selectedYear)
                        .month(month.id)
                        .startOf("month");
                    let end_date = moment(start_date).endOf("month");
                    self.InterventionApi.getDisponibilites(
                        start_date.format("YYYY-MM-DD"),
                        end_date.format("YYYY-MM-DD"),
                        params
                    ).then(function (res) {
                        _.assign(month, res);
                        self.$forceUpdate();
                    });
                });
            }
        },
        getExportParams(): Object {
            let params = {
                year: this.selectedYear,
                month: this.selectedMonth ? this.selectedMonth.id + 1 : null,
            };
            if (this.isFrequenceView) {
                params["frequences"] = _.chain(this.selectedFrequences)
                    .map("id")
                    .join(",")
                    .value();
                params["frequences_name"] = this.selectedFrequencesName;
            }
            return params;
        },
        // Events
        previous() {
            if (this.selectedMonth) {
                if (this.selectedMonth.id === 0) {
                    this.selectedYear -= 1;
                    this.selectedMonth = this.monthsList[11];
                } else {
                    this.selectedMonth =
                        this.monthsList[this.selectedMonth.id - 1];
                }
            } else {
                this.selectedYear -= 1;
            }
        },
        next() {
            if (this.selectedMonth) {
                if (this.selectedMonth.id === 11) {
                    this.selectedYear += 1;
                    this.selectedMonth = this.monthsList[0];
                } else {
                    this.selectedMonth =
                        this.monthsList[this.selectedMonth.id + 1];
                }
            } else {
                this.selectedYear += 1;
            }
        },
        selectMonth(month) {
            this.selectedMonth = month;
        },
        //
        openDisponibilitesEmployesModal(startDate, endDate) {
            this.showDisponibilitesEmployesModal = true;
            this.disponibilitesEmployesModalStartDate = startDate;
            this.disponibilitesEmployesModalEndDate = endDate;
        },
        closeDisponibilitesEmployesModal() {
            this.showDisponibilitesEmployesModal = false;
        },
        //
        openAbsencesNonAssigneesModal(startDate, endDate, type) {
            this.showAbsencesNonAssigneesModal = true;
            this.absencesNonAssigneesModalStartDate = startDate;
            this.absencesNonAssigneesModalEndDate = endDate;
            this.absencesNonAssigneesModalFilterType = type;
        },
        closeAbsencesNonAssigneesModal() {
            this.showAbsencesNonAssigneesModal = false;
        },
        //
        openInterventionList(
            startDate,
            endDate,
            unassigned_only = false,
            test_only = false
        ) {
            let params = {
                start_date: startDate,
                end_date: endDate,
                default_sort_id: "dureePrevue",
                default_sort_order: TableColumn.SortOrder.desc,
            };

            if (unassigned_only) {
                params["unassigned_only"] = unassigned_only;
            }
            if (test_only) {
                params["test_only"] = test_only;
            }

            let searchParams = new URLSearchParams(params);

            if (this.isFrequenceView) {
                _.each(this.selectedFrequences, function (freq) {
                    searchParams.append("frequences", freq.id);
                });
            }
            window.open(
                this.intervention_list_filter_url + searchParams.toString(),
                "_blank"
            );
        },
    },
    computed: {
        isFrequenceView: function () {
            return (
                !_.isNull(this.selectedFrequences) &&
                this.selectedFrequences.length > 0
            );
        },
        selectedFrequencesName: function () {
            let self = this;
            if (this.isFrequenceView) {
                return _.chain(this.frequencesList)
                    .filter(function (freq) {
                        return _.some(self.selectedFrequences, freq);
                    })
                    .map("shortname")
                    .join(",")
                    .value();
            }
            return "";
        },
    },
    watch: {
        selectedMonth: {
            immediate: false,
            handler: function () {
                this.createDayList();
            },
        },
        selectedYear: {
            immediate: false,
            handler: function () {
                this.createMonthsList();
            },
        },
        selectedFrequences: {
            immediate: false,
            handler: function () {
                this.getDisponibilites();
            },
        },
    },
};
